const detailData = {
  // 自有车，招商车和外挂车
  normal: {
    base: {
      label: '基础信息',
      tableData: {
        title: [
          {
            prop: 'plateNumber',
            label: '车牌号码',
            slot: true,
          },
          {
            prop: 'vehicleClassName',
            label: '车辆种类',
          },
          {
            prop: 'drivingLicenseOwner',
            label: '行驶证上所有人',
          },
          {
            prop: 'vehicleEarlyWarningDay',
            label: '行驶证预警天数',
          },
          {
            prop: 'drivingLicenseDate',
            label: '行驶证注册日期',
          },
          {
            prop: 'vehicleValidityTime',
            label: '行驶证失效日期',
          },
          {
            prop: 'drivingLicenseUrl',
            label: '行驶证正本',
            type: 'img',
          },
          {
            prop: 'adriverLicenseCopyUrl',
            label: '行驶证副本',
            type: 'img',
          },
          // {
          //   prop: 'carRegistrationPictureUrl',
          //   label: '车辆登记证书图片',
          //   type: 'img',
          // },
          // {
          //   prop: 'vehiclePictureUrl',
          //   label: '车辆图片',
          //   type: 'img',
          // },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    veheicleParams: {
      label: '车辆参数',
      tableData: {
        title: [
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
          {
            prop: 'energyTypeName',
            label: '能源类型',
          },
          {
            prop: 'vinNo',
            label: '车架号',
          },
          {
            prop: 'engineNo',
            label: '发动机号',
          },
          {
            prop: 'axleNumber',
            label: '轴数',
          },
          {
            prop: 'driveTypeName',
            label: '驱动形式',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    makeAndBrand: {
      label: '产地品牌',
      tableData: {
        title: [
          {
            prop: 'vehicleOriginName',
            label: '产地',
          },
          {
            prop: 'brandModelName',
            label: '品牌名称',
          },
          {
            prop: 'brandModelExt',
            label: '品牌型号',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    belong: {
      label: '车辆归属',
      tableData: {
        title: [
          {
            prop: 'orgName',
            label: '归属部门',
          },
          {
            prop: 'vehicleOwnerShipName',
            label: '车辆性质',
          },
          // {
          //   prop: 'lineCodeRule',
          //   label: '线路绑定',
          // },
          {
            prop: 'remark',
            label: '备注',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    oilConsumption: {
      label: '车辆油耗',
      tableData: {
        title: [
          {
            prop: 'isUseCarOilCost',
            label: '是否使用车辆油耗',
            slot: true,
          },
          {
            prop: 'loadFullOilCost',
            label: '载重油耗',
            unit: '升/百公里',
          },
          {
            prop: 'loadEmptyOilCost',
            label: '空载油耗',
            unit: '升/百公里',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    driverInfo: {
      label: '司机信息',
      tableData: {
        title: [
          {
            prop: 'driverMobilePhone',
            label: '主驾手机号',
          },
          {
            prop: 'driverUserName',
            label: '主驾姓名',
          },
          {
            prop: 'copilotDriverMobilePhone',
            label: '副驾手机号',
          },
          {
            prop: 'copilotDriverUserName',
            label: '副驾姓名',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    costInfo: {
      label: '成本信息',
      tableData: {
        title: [
          {
            prop: 'purchaseDate',
            label: '购买时间',
          },
          {
            prop: 'price',
            label: '购车价格',
          },
          {
            prop: 'residual',
            label: '残值',
          },
          {
            prop: 'depreciatedMonth',
            label: '折旧月数',
            unit: '月',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    insuranceInfo: {
      label: '保险信息',
      tableData: {
        title: [
          {
            prop: 'insuranceTimeEnd',
            label: '交强险到期时间',
          },
          // {
          //   prop: 'earlyWarningDay',
          //   label: '预警天数',
          // },
          {
            prop: 'busiInsuranceTimeEnd',
            label: '商业险到期时间',
          },
          // {
          //   prop: 'busiEarlyWarningDay',
          //   label: '预警天数',
          // },
          {
            prop: 'accidentInsuranceTimeEnd',
            label: '意外险到期时间',
          },
          {
            prop: 'excessInsuranceTimeEnd',
            label: '超赔险到期时间',
          },
          {
            prop: 'otherInsuranceTimeEnd',
            label: '其他险到期时间',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    maintanceInfo: {
      label: '保养信息',
      tableData: {
        title: [
          {
            prop: 'maintainMethodName',
            label: '保养方式',
          },
          // {
          //   prop: 'nextMaintainTime',
          //   label: '下次保养时间',
          // },
          // {
          //   prop: 'maintainWaringDay',
          //   label: '到期预警天数',
          // },
          // {
          //   prop: 'accumulatedMileage',
          //   label: '累计里程数（km）',
          // },
          // {
          //   prop: 'mileageDriven',
          //   label: '已行驶里程（km）',
          // },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    etcCardBind: {
      label: 'ETC卡绑定',
      tableData: {
        title: [
          {
            prop: 'etcCardNumber',
            label: 'ETC卡号',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
  },
  // 外调车
  outward: {
    base: {
      label: '基础信息',
      tableData: {
        title: [
          {
            prop: 'plateNumber',
            label: '车牌号码',
            slot: true,
          },
          {
            prop: 'vehicleClassName',
            label: '车辆种类',
          },
          {
            prop: 'driverMobilePhone',
            label: '主驾手机号',
          },
          {
            prop: 'driverUserName',
            label: '主驾姓名',
          },
          {
            prop: 'drivingLicenseOwner',
            label: '行驶证上所有人',
          },
          {
            prop: 'drivingLicenseUrl',
            label: '行驶证正本',
            type: 'img',
          },
          {
            prop: 'adriverLicenseCopyUrl',
            label: '行驶证副本',
            type: 'img',
          },
          {
            prop: 'specialOperCertFileIdUrl',
            label: '特殊运营证',
            type: 'img',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
    veheicleParams: {
      label: '车辆参数',
      tableData: {
        title: [
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
          {
            prop: 'vehicleStatusName',
            label: '车型',
          },
          {
            prop: 'vehicleLengthName',
            label: '车长',
          },
          {
            prop: 'vehicleLoad',
            label: '载重',
          },
        ],
        data: {

        },
        approveData: {

        },
      },
    },
  },
};

export default detailData;
